import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../home.css';
import { useLang } from '../i18n';
import PublicNav from '../components/PublicNav';

const ALGO = [
    { label: 'Saves',       pct: 95, icon: '📌', color: '#1d4ed8', note: 'Strongest reach signal' },
    { label: 'Reel Views',  pct: 78, icon: '🎬', color: '#2563eb', note: 'Watch time = priority' },
    { label: 'Comments',    pct: 72, icon: '💬', color: '#3b82f6', note: 'Engagement quality' },
    { label: 'Likes',       pct: 62, icon: '❤️', color: '#60a5fa', note: 'Base engagement signal' },
    { label: 'Followers',   pct: 55, icon: '👥', color: '#0891b2', note: 'Social proof' },
    { label: 'Story Views', pct: 45, icon: '👁️', color: '#06b6d4', note: 'Retention indicator' },
];

const STARS = Array.from({ length: 40 }, (_, i) => ({
    id: i, top: `${Math.random() * 100}%`, left: `${Math.random() * 100}%`,
    size: `${Math.random() * 2 + 1}px`, delay: `${Math.random() * 4}s`, dur: `${Math.random() * 3 + 2}s`,
}));

// ── Phone mockup screens ─────────────────────────────────────────────────────

function PhoneRegister() {
    return (
        <div className="og-phone">
            <div className="og-phone-screen">
                <div style={{ textAlign: 'center', marginBottom: 2 }}>
                    <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', margin: '0 auto 4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>◎</div>
                    <div style={{ fontSize: 9, fontWeight: 800, color: '#f1f5f9', letterSpacing: '-0.3px' }}>OrbitGrowth</div>
                </div>
                {[{ lbl: 'Email', val: 'you@email.com' }, { lbl: 'Password', val: '••••••••' }].map(f => (
                    <div key={f.lbl} style={{ background: 'rgba(255,255,255,0.06)', borderRadius: 6, padding: '5px 8px' }}>
                        <div style={{ fontSize: 7, color: '#64748b', marginBottom: 1 }}>{f.lbl}</div>
                        <div style={{ fontSize: 9, color: '#94a3b8' }}>{f.val}</div>
                    </div>
                ))}
                <div style={{ background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', borderRadius: 6, padding: '7px', textAlign: 'center', fontSize: 9, fontWeight: 700, color: '#fff', marginTop: 2 }}>
                    Create Account →
                </div>
                <div style={{ textAlign: 'center', fontSize: 7, color: '#334155', marginTop: 2 }}>Free · No card required</div>
                {/* Fake checkmark */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }}>
                    <div style={{ width: 14, height: 14, borderRadius: '50%', background: 'rgba(6,182,212,0.2)', border: '1px solid #06b6d4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8, color: '#06b6d4' }}>✓</div>
                    <div style={{ fontSize: 7, color: '#64748b' }}>Instant activation</div>
                </div>
            </div>
        </div>
    );
}

function PhoneDeposit() {
    return (
        <div className="og-phone">
            <div className="og-phone-screen">
                <div style={{ fontSize: 9, fontWeight: 700, color: '#60a5fa', marginBottom: 2 }}>💰 Add Balance</div>
                <div style={{ background: 'rgba(29,78,216,0.1)', borderRadius: 6, padding: '6px 8px', border: '1px solid rgba(29,78,216,0.25)' }}>
                    <div style={{ fontSize: 7, color: '#64748b', marginBottom: 1 }}>Amount</div>
                    <div style={{ fontSize: 16, fontWeight: 900, color: '#f1f5f9', letterSpacing: '-0.5px' }}>€100</div>
                </div>
                <div style={{ fontSize: 7, color: '#60a5fa', fontWeight: 600, marginTop: 2 }}>🎁 +5% bonus = €105 credit</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginTop: 2 }}>
                    {['USDT', 'BTC', 'ETH', 'LTC'].map(c => (
                        <div key={c} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 5, padding: '4px 6px', textAlign: 'center', fontSize: 8, color: '#94a3b8', border: '1px solid rgba(255,255,255,0.08)' }}>{c}</div>
                    ))}
                </div>
                <div style={{ background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', borderRadius: 6, padding: '7px', textAlign: 'center', fontSize: 9, fontWeight: 700, color: '#fff', marginTop: 4 }}>
                    Pay with Crypto →
                </div>
                <div style={{ textAlign: 'center', fontSize: 7, color: '#334155', marginTop: 2 }}>Instant · Secure · Anonymous</div>
            </div>
        </div>
    );
}

function PhoneOrder() {
    return (
        <div className="og-phone">
            <div className="og-phone-screen">
                <div style={{ fontSize: 9, fontWeight: 700, color: '#60a5fa', marginBottom: 4 }}>📈 New Order</div>
                <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 6, padding: '5px 8px', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <div style={{ fontSize: 7, color: '#64748b', marginBottom: 1 }}>Service</div>
                    <div style={{ fontSize: 9, color: '#f1f5f9' }}>❤️ Likes — Post+Reel</div>
                </div>
                <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 6, padding: '5px 8px', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <div style={{ fontSize: 7, color: '#64748b', marginBottom: 1 }}>Link</div>
                    <div style={{ fontSize: 8, color: '#94a3b8' }}>instagram.com/p/xyz</div>
                </div>
                <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 6, padding: '5px 8px', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <div style={{ fontSize: 7, color: '#64748b', marginBottom: 1 }}>Quantity</div>
                    <div style={{ fontSize: 9, color: '#f1f5f9', fontWeight: 700 }}>500</div>
                </div>
                {/* Live progress bar */}
                <div style={{ marginTop: 4 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 7, color: '#64748b', marginBottom: 3 }}>
                        <span>Delivered</span><span style={{ color: '#1d4ed8', fontWeight: 700 }}>342 / 500</span>
                    </div>
                    <div style={{ height: 5, background: 'rgba(255,255,255,0.08)', borderRadius: 100, overflow: 'hidden' }}>
                        <div style={{ width: '68%', height: '100%', background: 'linear-gradient(90deg,#1d4ed8,#06b6d4)', borderRadius: 100 }} />
                    </div>
                </div>
                <div style={{ background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', borderRadius: 6, padding: '7px', textAlign: 'center', fontSize: 9, fontWeight: 700, color: '#fff', marginTop: 4 }}>
                    Place Order →
                </div>
            </div>
        </div>
    );
}

const PHONE_COMPONENTS = { register: <PhoneRegister />, deposit: <PhoneDeposit />, order: <PhoneOrder /> };

// ── Why Better — inline multilingual ─────────────────────────────────────────
const BETTER_CONTENT = {
    en: {
        label: 'The OrbitGrowth Difference', title: "Why we're better than the rest",
        sub: 'Most services use bots or resell low-quality engagement. We deliver authentic interactions from real accounts — no fakes, just real results.',
        othersTitle: 'Typical services', usTitle: 'OrbitGrowth',
        others: ['Bots and mass-generated fake profiles', 'Instant drops after delivery', 'High ban risk — unnatural activity patterns', 'Reselling from the same low-quality shared pool', 'Zero quality control or transparency', 'No dedicated infrastructure'],
        us: ['Real accounts with authentic activity history', 'Accounts that engage like real users', 'AI-powered natural behavior — lowest ban rate', 'Proprietary engagement technology — no reselling', 'Real-time quality monitoring on every order', 'Consistent, reliable delivery with full quality control'],
    },
    it: {
        label: 'La Differenza OrbitGrowth', title: 'Perché siamo migliori degli altri',
        sub: 'La maggior parte dei servizi usa bot o rivende engagement di bassa qualità. Noi consegniamo interazioni autentiche da account reali — niente fake, solo risultati veri.',
        othersTitle: 'Servizi tipici', usTitle: 'OrbitGrowth',
        others: ['Bot e profili falsi generati in massa', 'Calo immediato dopo la consegna', 'Alto rischio di ban per attività innaturali', 'Rivendono dallo stesso pool condiviso di bassa qualità', 'Zero controllo qualità o trasparenza', 'Nessuna infrastruttura dedicata'],
        us: ['Account reali con cronologia di attività autentica', 'Account che interagiscono come utenti veri', 'Comportamento naturale AI — tasso di ban minimo del settore', 'Tecnologia di engagement proprietaria — nessuna rivendita', 'Monitoraggio qualità in tempo reale su ogni ordine', 'Consegna affidabile e costante con controllo qualità totale'],
    },
    es: {
        label: 'La Diferencia OrbitGrowth', title: 'Por qué somos mejores',
        sub: 'La mayoría usa bots o revende engagement de baja calidad. Nosotros entregamos interacciones auténticas de cuentas reales — sin fakes, solo resultados reales.',
        othersTitle: 'Servicios típicos', usTitle: 'OrbitGrowth',
        others: ['Bots y perfiles falsos generados en masa', 'Caídas instantáneas después de la entrega', 'Alto riesgo de ban por actividad poco natural', 'Reventa del mismo pool compartido de baja calidad', 'Sin control de calidad ni transparencia', 'Sin infraestructura propia'],
        us: ['Cuentas reales con historial de actividad auténtica', 'Cuentas que interactúan como usuarios reales', 'Comportamiento natural AI — tasa de ban más baja', 'Tecnología de engagement propietaria — sin reventa', 'Monitoreo de calidad en tiempo real en cada pedido', 'Entrega confiable y consistente con control de calidad total'],
    },
    de: {
        label: 'Der OrbitGrowth-Unterschied', title: 'Warum wir besser sind',
        sub: 'Die meisten Dienste nutzen Bots oder verkaufen minderwertige Engagements weiter. Wir liefern authentische Interaktionen von echten Konten — keine Fakes, nur echte Ergebnisse.',
        othersTitle: 'Typische Dienste', usTitle: 'OrbitGrowth',
        others: ['Bots und massengenerierte Fake-Profile', 'Sofortige Einbrüche nach der Lieferung', 'Hohes Ban-Risiko durch unnatürliche Aktivitäten', 'Weiterverkauf aus demselben minderwertigen Pool', 'Keine Qualitätskontrolle oder Transparenz', 'Keine eigene Infrastruktur'],
        us: ['Echte Konten mit authentischer Aktivitätshistorie', 'Konten, die wie echte Nutzer interagieren', 'KI-gestütztes natürliches Verhalten — niedrigste Ban-Rate', 'Proprietäre Engagement-Technologie — kein Weiterverkauf', 'Echtzeit-Qualitätsüberwachung bei jeder Bestellung', 'Zuverlässige, konsistente Lieferung mit voller Qualitätskontrolle'],
    },
    fr: {
        label: 'La Différence OrbitGrowth', title: 'Pourquoi nous sommes meilleurs',
        sub: "La plupart des services utilisent des bots ou revendent de l'engagement de mauvaise qualité. Nous livrons des interactions authentiques depuis de vrais comptes — pas de faux, que des résultats réels.",
        othersTitle: 'Services typiques', usTitle: 'OrbitGrowth',
        others: ['Bots et faux profils générés en masse', 'Chutes immédiates après livraison', 'Risque élevé de ban par activité non naturelle', 'Revente du même pool partagé de mauvaise qualité', 'Zéro contrôle qualité ou transparence', 'Aucune infrastructure dédiée'],
        us: ['Vrais comptes avec historique d\'activité authentique', 'Comptes qui interagissent comme de vrais utilisateurs', 'Comportement naturel IA — taux de ban le plus bas', 'Technologie d\'engagement propriétaire — aucune revente', 'Surveillance qualité en temps réel sur chaque commande', 'Livraison fiable et consistante avec contrôle qualité total'],
    },
    ru: {
        label: 'Отличие OrbitGrowth', title: 'Почему мы лучше других',
        sub: 'Большинство сервисов используют ботов или перепродают низкокачественный трафик. Мы доставляем настоящие взаимодействия от реальных аккаунтов — никаких фейков, только реальные результаты.',
        othersTitle: 'Типичные сервисы', usTitle: 'OrbitGrowth',
        others: ['Боты и массово сгенерированные фейки', 'Мгновенный отток после доставки', 'Высокий риск блокировки — неестественная активность', 'Перепродажа из одного низкокачественного пула', 'Нулевой контроль качества и прозрачности', 'Нет собственной инфраструктуры'],
        us: ['Реальные аккаунты с подлинной историей активности', 'Аккаунты, которые взаимодействуют как настоящие пользователи', 'ИИ-поведение — минимальный процент блокировок', 'Собственная технология — без перепродажи', 'Мониторинг качества в реальном времени на каждом заказе', 'Стабильная и надёжная доставка с полным контролем качества'],
    },
};

// ── Zenith — inline multilingual ─────────────────────────────────────────────
const ZENITH_CONTENT = {
    en: {
        badge: 'COMING SOON', label: 'Premium Managed Service',
        title: 'Complete Instagram Account Management',
        sub: 'Zenith handles everything — strategy, content creation, daily engagement and growth reporting. Just hand us your account.',
        cta: '📩 Contact on Telegram for early access →',
        plans: [
            { name: 'Starter', price: '€299', period: '/mo', desc: '500 new followers/month · Daily likes on 5–10 posts · 1 story/week' },
            { name: 'Growth', price: '€599', period: '/mo', desc: '1,500 followers/month · Daily likes + AI comments · 3 stories/week · Weekly report' },
            { name: 'VIP',     price: '€999', period: '/mo', desc: '3,000+ followers/month · Full content management · Daily posts + reels · Weekly calls' },
        ],
    },
    it: {
        badge: 'PROSSIMAMENTE', label: 'Servizio Premium Gestito',
        title: "Gestione Completa dell'Account Instagram",
        sub: 'Zenith si occupa di tutto — strategia, creazione di contenuti, engagement quotidiano e report di crescita. Affidaci il tuo account.',
        cta: '📩 Contattaci su Telegram per accesso anticipato →',
        plans: [
            { name: 'Starter', price: '€299', period: '/mese', desc: '500 nuovi follower/mese · Like quotidiani su 5–10 post · 1 storia/settimana' },
            { name: 'Growth', price: '€599', period: '/mese', desc: '1.500 follower/mese · Like + commenti AI · 3 storie/sett · Report settimanale' },
            { name: 'VIP',    price: '€999', period: '/mese', desc: '3.000+ follower/mese · Gestione contenuti completa · Post + reel giornalieri · Call settimanali' },
        ],
    },
    es: {
        badge: 'PRÓXIMAMENTE', label: 'Servicio Premium Gestionado',
        title: 'Gestión Completa de Instagram',
        sub: 'Zenith se encarga de todo — estrategia, contenido, engagement diario y reportes. Solo entréganos tu cuenta.',
        cta: '📩 Contáctanos en Telegram para acceso anticipado →',
        plans: [
            { name: 'Starter', price: '€299', period: '/mes', desc: '500 seguidores/mes · Likes diarios en 5–10 posts · 1 historia/semana' },
            { name: 'Growth', price: '€599', period: '/mes', desc: '1.500 seguidores/mes · Likes + comentarios IA · 3 historias/sem · Informe semanal' },
            { name: 'VIP',    price: '€999', period: '/mes', desc: '3.000+ seguidores/mes · Gestión de contenido completa · Posts + reels · Llamadas semanales' },
        ],
    },
    de: {
        badge: 'BALD VERFÜGBAR', label: 'Premium Managed Service',
        title: 'Vollständiges Instagram-Account-Management',
        sub: 'Zenith kümmert sich um alles — Strategie, Content-Erstellung, tägliches Engagement und Wachstumsberichte. Übergib uns einfach dein Konto.',
        cta: '📩 Telegram kontaktieren für frühen Zugang →',
        plans: [
            { name: 'Starter', price: '€299', period: '/Mo', desc: '500 Follower/Monat · Tägliche Likes auf 5–10 Posts · 1 Story/Woche' },
            { name: 'Growth', price: '€599', period: '/Mo', desc: '1.500 Follower/Mon · Likes + KI-Kommentare · 3 Stories/Wo · Wochenbericht' },
            { name: 'VIP',    price: '€999', period: '/Mo', desc: '3.000+ Follower/Mon · Vollst. Content-Management · Tägl. Posts + Reels · Wochen-Calls' },
        ],
    },
    fr: {
        badge: 'BIENTÔT', label: 'Service Premium Géré',
        title: 'Gestion Complète Instagram',
        sub: "Zenith s'occupe de tout — stratégie, contenu, engagement quotidien et rapports de croissance. Confiez-nous votre compte.",
        cta: "📩 Contacter sur Telegram pour l'accès anticipé →",
        plans: [
            { name: 'Starter', price: '€299', period: '/mois', desc: '500 abonnés/mois · Likes quotidiens sur 5–10 posts · 1 story/semaine' },
            { name: 'Growth', price: '€599', period: '/mois', desc: '1 500 abonnés/mois · Likes + commentaires IA · 3 stories/sem · Rapport hebdomadaire' },
            { name: 'VIP',    price: '€999', period: '/mois', desc: '3 000+ abonnés/mois · Gestion complète du contenu · Posts + reels · Appels hebdo' },
        ],
    },
    ru: {
        badge: 'СКОРО', label: 'Премиум Управляемый Сервис',
        title: 'Полное Управление Instagram-Аккаунтом',
        sub: 'Zenith берёт на себя всё — стратегию, создание контента, ежедневный энгейджмент и отчёты о росте. Просто передай нам свой аккаунт.',
        cta: '📩 Написать в Telegram для раннего доступа →',
        plans: [
            { name: 'Starter', price: '€299', period: '/мес', desc: '500 подписчиков/мес · Ежедневные лайки на 5–10 постов · 1 сторис/неделя' },
            { name: 'Growth', price: '€599', period: '/мес', desc: '1 500 подписчиков/мес · Лайки + ИИ-комментарии · 3 сторис/нед · Еженед. отчёт' },
            { name: 'VIP',    price: '€999', period: '/мес', desc: '3 000+ подписчиков/мес · Полное управление контентом · Ежедн. посты + рилс · Звонки' },
        ],
    },
};

// ── Styles ───────────────────────────────────────────────────────────────────

const c = {
    root:  { minHeight: '100vh', background: '#050810', color: '#f1f5f9', fontFamily: '"Segoe UI", system-ui, sans-serif' },
    nav:      { position: 'sticky', top: 0, zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 48px', background: 'rgba(5,8,16,0.92)', backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(29,78,216,0.15)', gap: 16 },
    logo:     { display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: '#f1f5f9', flexShrink: 0 },
    logoIcon: { width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 },
    logoTxt:  { fontWeight: 800, fontSize: 20, letterSpacing: '-0.5px' },
    navLinks: { display: 'flex', gap: 24, alignItems: 'center', flex: 1, justifyContent: 'center' },
    navLink:  { color: '#94a3b8', textDecoration: 'none', fontSize: 14, fontWeight: 500 },
    navCtas:  { display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 },
    hero:      { position: 'relative', minHeight: '90vh', display: 'flex', alignItems: 'center', overflow: 'hidden', padding: '80px 48px' },
    heroInner: { width: '100%', maxWidth: 1200, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 60 },
    heroCopy:  { flex: 1, maxWidth: 580 },
    badge:     { display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 14px', background: 'rgba(29,78,216,0.15)', border: '1px solid rgba(29,78,216,0.3)', borderRadius: 100, fontSize: 13, color: '#60a5fa', marginBottom: 24, fontWeight: 600 },
    h1:        { fontSize: 56, fontWeight: 900, lineHeight: 1.1, marginBottom: 20, letterSpacing: '-1.5px' },
    sub:       { fontSize: 18, color: '#94a3b8', lineHeight: 1.7, marginBottom: 40, maxWidth: 480, textWrap: 'balance' },
    ctas:      { display: 'flex', gap: 16, flexWrap: 'wrap' },
    statsBar:  { display: 'flex', justifyContent: 'center', gap: 0, borderTop: '1px solid rgba(255,255,255,0.06)', borderBottom: '1px solid rgba(255,255,255,0.06)', background: 'rgba(255,255,255,0.02)' },
    statItem:  { flex: 1, maxWidth: 240, textAlign: 'center', padding: '28px 24px', borderRight: '1px solid rgba(255,255,255,0.06)' },
    statNum:   { fontSize: 36, fontWeight: 800, display: 'block', letterSpacing: '-1px' },
    statLbl:   { fontSize: 13, color: '#64748b', marginTop: 4, display: 'block' },
    section:   { maxWidth: 1200, margin: '0 auto', padding: '96px 48px' },
    secH:      { fontSize: 13, fontWeight: 700, color: '#1d4ed8', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 16, display: 'block' },
    secTitle:  { fontSize: 40, fontWeight: 800, marginBottom: 16, letterSpacing: '-0.5px' },
    secSub:    { fontSize: 17, color: '#64748b', maxWidth: 600, lineHeight: 1.7, textWrap: 'balance' },
    featGrid:  { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginTop: 56 },
    featCard:  { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: 28 },
    featIcon:  { fontSize: 32, marginBottom: 16, display: 'block' },
    featTitle: { fontSize: 17, fontWeight: 700, marginBottom: 10 },
    featDesc:  { fontSize: 14, color: '#64748b', lineHeight: 1.7 },
    howWrap:   { background: 'rgba(29,78,216,0.04)', borderTop: '1px solid rgba(29,78,216,0.1)', borderBottom: '1px solid rgba(29,78,216,0.1)', padding: '96px 0' },
    stepsGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0, marginTop: 56, alignItems: 'start' },
    algoWrap:  { background: '#050810', padding: '96px 0', borderBottom: '1px solid rgba(255,255,255,0.06)' },
    algoGrid:  { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 14, marginTop: 56 },
    algoRow:   { display: 'flex', alignItems: 'center', gap: 12, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 12, padding: '14px 18px' },
    algoIcon:  { fontSize: 20, minWidth: 26 },
    algoMeta:  { minWidth: 110 },
    algoLabel: { fontSize: 14, fontWeight: 600, color: '#f1f5f9' },
    algoNote:  { fontSize: 11, color: '#475569', marginTop: 2 },
    algoBarBg: { flex: 1, height: 7, background: 'rgba(255,255,255,0.08)', borderRadius: 100, overflow: 'hidden' },
    algoPct:   { fontSize: 13, fontWeight: 700, minWidth: 34, textAlign: 'right' },
    svcGrid:   { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginTop: 56 },
    svcCard:   { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 14, padding: '24px 20px', cursor: 'pointer', display: 'flex', flexDirection: 'column' },
    svcIcon:   { fontSize: 28, marginBottom: 12, display: 'block' },
    svcLabel:  { fontSize: 16, fontWeight: 700, marginBottom: 6 },
    svcDesc:   { fontSize: 13, color: '#64748b', lineHeight: 1.6, flex: 1 },
    svcFrom:   { marginTop: 16, paddingTop: 14, borderTop: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    svcPrice:  { fontSize: 13, fontWeight: 700, color: '#1d4ed8' },
    svcTags:   { display: 'flex', gap: 5 },
    svcTag:    { fontSize: 10, padding: '2px 8px', borderRadius: 100, background: 'rgba(6,182,212,0.12)', color: '#06b6d4', fontWeight: 600 },
    subWrap:   { background: 'rgba(29,78,216,0.03)', borderTop: '1px solid rgba(29,78,216,0.1)', padding: '96px 0' },
    planGrid:  { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 28, marginTop: 64, alignItems: 'stretch' },
    planCard:  { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20, padding: '36px 28px', position: 'relative', display: 'flex', flexDirection: 'column' },
    planCardHot: { border: '1px solid rgba(29,78,216,0.55)', background: 'rgba(29,78,216,0.07)' },
    planBadge: { position: 'absolute', top: -15, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(135deg,#1d4ed8,#06b6d4)', color: '#fff', fontSize: 11, fontWeight: 700, padding: '4px 16px', borderRadius: 100, whiteSpace: 'nowrap', letterSpacing: 0.5 },
    planName:  { fontSize: 22, fontWeight: 800, marginBottom: 4, color: '#f1f5f9' },
    planDesc:  { fontSize: 13, color: '#64748b', marginBottom: 20 },
    planPrice: { display: 'flex', alignItems: 'baseline', gap: 3, marginBottom: 24 },
    planCur:   { fontSize: 20, fontWeight: 700, color: '#60a5fa' },
    planAmt:   { fontSize: 52, fontWeight: 900, lineHeight: 1, color: '#f1f5f9', letterSpacing: '-3px' },
    planPer:   { fontSize: 14, color: '#64748b', marginLeft: 2 },
    planFeat:  { listStyle: 'none', padding: 0, margin: '0 0 28px 0', display: 'flex', flexDirection: 'column', gap: 10, flex: 1 },
    planFeatItem: { fontSize: 14, color: '#94a3b8', display: 'flex', alignItems: 'flex-start', gap: 8 },
    planCheck: { color: '#1d4ed8', fontWeight: 700, minWidth: 14, marginTop: 1 },
    subNote:   { textAlign: 'center', marginTop: 48, fontSize: 13, color: '#334155' },
    ctaWrap:   { textAlign: 'center', padding: '96px 48px', background: 'radial-gradient(ellipse 60% 60% at 50% 50%, rgba(29,78,216,0.12) 0%, transparent 70%)' },
    ctaTitle:  { fontSize: 44, fontWeight: 900, marginBottom: 16, letterSpacing: '-0.5px' },
    ctaSub:    { fontSize: 18, color: '#64748b', marginBottom: 40 },
    footer:     { borderTop: '1px solid rgba(255,255,255,0.06)', padding: '32px 48px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 },
    footerLogo: { color: '#f1f5f9', fontWeight: 700, fontSize: 16, display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' },
    footerLinks:{ display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap' },
    footerLink: { color: '#64748b', textDecoration: 'none', fontSize: 13 },
    footerCopy: { color: '#334155', fontSize: 12 },
};

// ── Component ────────────────────────────────────────────────────────────────

// Map API task_types → display items for speed section
const SPEED_MAP = [
    { key: 'like_post',          icon: '❤️', label: 'Likes',       note: '/post',    fallback: 50 },
    { key: 'follow_user',        icon: '👥', label: 'Follows',     note: '/profile', fallback: 25 },
    { key: 'watch_user_stories', icon: '👁️', label: 'Story Views', note: '/story',   fallback: 100 },
    { key: 'watch_specific_reel',icon: '🎬', label: 'Reel Views',  note: '/reel',    fallback: 80 },
    { key: 'comment_post',       icon: '💬', label: 'Comments',    note: '/post',    fallback: 5 },
    { key: 'save_post',          icon: '📌', label: 'Saves',       note: '/post',    fallback: 30 },
];

export default function Home() {
    const navigate = useNavigate();
    const isLoggedIn = !!localStorage.getItem('token');
    const { t, fmtEur, lang } = useLang();
    const [speedData, setSpeedData] = useState(null);

    useEffect(() => {
        if (isLoggedIn) navigate('/dashboard', { replace: true });
    }, [isLoggedIn, navigate]);

    // Fetch real delivery speeds
    useEffect(() => {
        axios.get('/public/delivery-stats')
            .then(res => { if (res.data?.stats) setSpeedData(res.data.stats); })
            .catch(() => {});
    }, []);

    const home   = t('home');
    const nav    = t('nav');
    const common = t('common');
    const bc     = BETTER_CONTENT[lang] || BETTER_CONTENT.en;
    const zc     = ZENITH_CONTENT[lang]  || ZENITH_CONTENT.en;

    return (
        <div style={c.root}>
            {/* Stars */}
            <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
                {STARS.map(s => (
                    <div key={s.id} className="og-star" style={{ top: s.top, left: s.left, width: s.size, height: s.size, '--d': s.dur, '--delay': s.delay }} />
                ))}
            </div>

            {/* ── NAV ───────────────────────────────────────────────────── */}
            <PublicNav />

            {/* ── HERO ──────────────────────────────────────────────────── */}
            <section style={c.hero} className="og-hero-section">
                {/* Background elements */}
                <div className="og-dot-grid" />
                <div className="og-hero-glow og-hero-glow-purple" />
                <div className="og-hero-glow og-hero-glow-cyan" />

                <div style={c.heroInner} className="og-hero-inner">
                    <div style={c.heroCopy} className="og-fade-up">
                        <div style={c.badge}>
                            <span className="og-badge-live">
                                <span className="og-badge-live-dot" />
                                {home.badge.replace('🚀 ', '')}
                            </span>
                        </div>
                        <h1 style={c.h1} className="og-h1">
                            {home.h1_1}<br />
                            <span className="og-shimmer-text">{home.h1_2}</span>
                        </h1>
                        <p style={c.sub}>{home.sub}</p>
                        <div style={c.ctas} className="og-hero-ctas">
                            <button onClick={() => navigate('/register')} className="og-btn-primary">{home.cta1}</button>
                            <button onClick={() => navigate('/login')} className="og-btn-secondary">{home.cta2}</button>
                        </div>
                        {home.trialCredit && (
                            <div style={{ marginTop: 16, display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 18px', background: 'rgba(6,182,212,0.1)', border: '1px solid rgba(6,182,212,0.25)', borderRadius: 100, fontSize: 13, color: '#67e8f9', fontWeight: 600 }}>
                                <span style={{ fontSize: 15 }}>🎁</span> {home.trialCredit}
                            </div>
                        )}
                        {/* Contact mini-row under hero CTAs */}
                        <div style={{ marginTop: 20, display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap' }}>
                            <a href="https://t.me/orbitgrowth" target="_blank" rel="noopener noreferrer"
                                style={{ color: '#60a5fa', fontSize: 13, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 5 }}>
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/></svg>
                                @orbitgrowth
                            </a>
                            <span style={{ color: '#1e293b' }}>·</span>
                            <a href="mailto:orbitgrowth.staff@gmail.com"
                                style={{ color: '#475569', fontSize: 13, textDecoration: 'none' }}>
                                orbitgrowth.staff@gmail.com
                            </a>
                        </div>
                    </div>
                    <div className="og-orbit-wrap">
                        <div className="og-ring og-ring-4" />
                        <div className="og-ring og-ring-3" />
                        <div className="og-ring og-ring-2" />
                        <div className="og-ring og-ring-1" />
                        <div className="og-dot og-dot-1">❤️</div>
                        <div className="og-dot og-dot-2">💬</div>
                        <div className="og-dot og-dot-3">👥</div>
                        <div className="og-dot og-dot-4">👁️</div>
                        <div className="og-dot og-dot-5">🎬</div>
                        <div className="og-orbit-center">
                            <img src="/logo.svg" alt="OrbitGrowth" style={{ width: 68, height: 'auto' }} />
                        </div>
                    </div>
                </div>
            </section>

            {/* ── STATS BAR ─────────────────────────────────────────────── */}
            <div style={c.statsBar} className="og-stats-bar" role="list">
                {home.stats.map(s => (
                    <div key={s.lbl} style={c.statItem}>
                        <span style={c.statNum} className="og-stat-num">{s.num}</span>
                        <span style={c.statLbl}>{s.lbl}</span>
                    </div>
                ))}
            </div>

            {/* ── FEATURES ──────────────────────────────────────────────── */}
            <section id="features">
                <div style={{ ...c.section, textAlign: 'center' }} className="og-section">
                    <img src="/logo.svg" alt="OrbitGrowth" style={{ height: 52, width: 'auto', display: 'block', margin: '0 auto 20px' }} />
                    <span style={c.secH}>{home.featLabel}</span>
                    <h2 style={c.secTitle}>{home.featTitle.split('\n').map((l, i) => <React.Fragment key={i}>{l}{i === 0 && <br />}</React.Fragment>)}</h2>
                    <p style={{ ...c.secSub, margin: '0 auto' }}>{home.featSub}</p>
                    <div style={c.featGrid} className="og-feature-grid">
                        {home.features.map(f => (
                            <div key={f.title} style={c.featCard} className="og-feature-card">
                                <span style={c.featIcon}>{f.icon}</span>
                                <div style={c.featTitle}>{f.title}</div>
                                <div style={c.featDesc}>{f.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── HOW IT WORKS (redesigned) ─────────────────────────────── */}
            <div style={c.howWrap} id="how-it-works" className="og-how-bg og-howwrap">
                <div style={c.section} className="og-section">
                    <span style={c.secH}>{home.howLabel}</span>
                    <h2 style={c.secTitle}>{home.howTitle}</h2>
                    <p style={c.secSub}>{home.howSub}</p>

                    {/* Steps with phone mockups */}
                    <div style={{ display: 'flex', gap: 0, marginTop: 64, alignItems: 'flex-start' }} className="og-steps-grid">
                        {home.steps.map((s, i) => (
                            <React.Fragment key={s.n}>
                                <div className="og-step-card" style={{ flex: 1 }}>
                                    {/* Number badge + icon */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        <div className="og-step-num-badge">{s.n}</div>
                                        <div style={{ fontSize: 28 }}>{s.icon}</div>
                                    </div>
                                    {/* Phone mockup */}
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
                                        {PHONE_COMPONENTS[s.screen]}
                                    </div>
                                    {/* Text */}
                                    <div>
                                        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>{s.title}</div>
                                        <div style={{ fontSize: 14, color: '#64748b', lineHeight: 1.7 }}>{s.desc}</div>
                                    </div>
                                </div>
                                {/* Connector arrow between steps */}
                                {i < home.steps.length - 1 && (
                                    <div className="og-step-connector">
                                        <div className="og-step-connector-arrow" />
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── ALGORITHM INFOGRAPHIC ─────────────────────────────────── */}
            <div style={c.algoWrap} className="og-algowrap">
                <div style={c.section} className="og-section">
                    <span style={c.secH}>{home.algoLabel}</span>
                    <h2 style={c.secTitle}>{home.algoTitle}<br /><span className="og-gradient-text"></span></h2>
                    <p style={c.secSub}>{home.algoSub}</p>
                    <div style={c.algoGrid} className="og-algo-grid">
                        {ALGO.map(a => (
                            <div key={a.label} style={c.algoRow} className="og-algo-row">
                                <span style={c.algoIcon}>{a.icon}</span>
                                <div style={c.algoMeta}>
                                    <div style={c.algoLabel}>{a.label}</div>
                                    <div style={c.algoNote}>{a.note}</div>
                                </div>
                                <div style={c.algoBarBg}>
                                    <div style={{ width: `${a.pct}%`, height: '100%', borderRadius: 100, background: `linear-gradient(90deg, ${a.color}, #06b6d4)` }} />
                                </div>
                                <span style={{ ...c.algoPct, color: a.color }}>{a.pct}%</span>
                            </div>
                        ))}
                    </div>
                    <p style={{ marginTop: 20, fontSize: 11, color: '#1e293b', fontStyle: 'italic' }}>{home.algoDisclaimer}</p>
                </div>
            </div>

            {/* ── DELIVERY SPEED ────────────────────────────────────────── */}
            <div style={{ background: '#050810', borderTop: '1px solid rgba(255,255,255,0.06)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                <div style={{ ...c.section, paddingTop: 64, paddingBottom: 64 }} className="og-section">
                    <span style={c.secH}>delivery speed</span>
                    <h2 style={{ ...c.secTitle, marginBottom: 12, fontSize: 34 }}>{home.speedTitle || 'Guaranteed minimum delivery rates'}</h2>
                    <p style={{ ...c.secSub, marginBottom: 40, fontSize: 14 }}>{home.speedSub || 'Real delivery rates based on recent order data. Minimum rates guaranteed — capacity scales automatically.'}</p>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 14 }} className="og-speed-grid">
                        {SPEED_MAP.map(item => {
                            const apiData = speedData?.[item.key];
                            const speed = apiData ? apiData.avg_display : item.fallback;
                            return (
                                <div key={item.label} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 14, padding: '20px 18px', textAlign: 'center' }}>
                                    <div style={{ fontSize: 28, marginBottom: 8 }}>{item.icon}</div>
                                    <div style={{ fontSize: 22, fontWeight: 800, color: '#60a5fa', letterSpacing: '-0.5px' }}>~{speed}<span style={{ fontSize: 13, color: '#475569', fontWeight: 400 }}>/h</span></div>
                                    <div style={{ fontSize: 13, fontWeight: 600, color: '#f1f5f9', marginTop: 4 }}>{item.label}</div>
                                    <div style={{ fontSize: 11, color: '#334155', marginTop: 2 }}>{item.note}</div>
                                </div>
                            );
                        })}
                    </div>
                    <p style={{ marginTop: 20, fontSize: 11, color: '#1e293b', fontStyle: 'italic' }}>
                        {home.speedNote || '* Rates based on recent delivery data. Minimum guaranteed — capacity scales automatically.'}
                    </p>
                </div>
            </div>

            {/* ── WHY BETTER ────────────────────────────────────────────── */}
            <div style={{ background: 'rgba(0,0,0,0.25)', borderTop: '1px solid rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                <div style={c.section} className="og-section">
                    <span style={c.secH}>{bc.label}</span>
                    <h2 style={c.secTitle}>{bc.title}</h2>
                    <p style={{ ...c.secSub, marginBottom: 48 }}>{bc.sub}</p>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }} className="og-better-grid">
                        {/* Others column */}
                        <div style={{ background: 'rgba(239,68,68,0.04)', border: '1px solid rgba(239,68,68,0.15)', borderRadius: 20, padding: '32px 28px' }}>
                            <div style={{ fontSize: 15, fontWeight: 700, color: '#f87171', marginBottom: 24 }}>❌ {bc.othersTitle}</div>
                            {bc.others.map((item, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 14 }}>
                                    <span style={{ color: '#ef4444', fontWeight: 700, marginTop: 1, flexShrink: 0 }}>✕</span>
                                    <span style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6 }}>{item}</span>
                                </div>
                            ))}
                        </div>
                        {/* OrbitGrowth column */}
                        <div style={{ background: 'rgba(29,78,216,0.06)', border: '1px solid rgba(29,78,216,0.28)', borderRadius: 20, padding: '32px 28px', position: 'relative', overflow: 'hidden' }}>
                            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: 'linear-gradient(90deg, #1d4ed8, #06b6d4)' }} />
                            <div style={{ fontSize: 15, fontWeight: 700, color: '#60a5fa', marginBottom: 24 }}>✓ {bc.usTitle}</div>
                            {bc.us.map((item, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 14 }}>
                                    <span style={{ color: '#22c55e', fontWeight: 700, marginTop: 1, flexShrink: 0 }}>✓</span>
                                    <span style={{ fontSize: 14, color: '#94a3b8', lineHeight: 1.6 }}>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* ── SERVICES ──────────────────────────────────────────────── */}
            <section id="services">
                <div style={c.section} className="og-section">
                    <span style={c.secH}>{home.svcLabel}</span>
                    <h2 style={c.secTitle}>{home.svcTitle}</h2>
                    <p style={c.secSub}>{home.svcSub}</p>
                    <div style={c.svcGrid} className="og-svc-grid">
                        {home.services.map(s => (
                            <div key={s.label} style={c.svcCard} className="og-svc-card" onClick={() => navigate('/register')}>
                                <span style={c.svcIcon}>{s.icon}</span>
                                <div style={c.svcLabel}>{s.label}</div>
                                <div style={c.svcDesc}>{s.desc}</div>
                                <div style={c.svcFrom}>
                                    <span style={c.svcPrice}>{home.svcFrom} {fmtEur(s.from)} / {s.per}</span>
                                    <div style={c.svcTags}>{s.tags.map(tg => <span key={tg} style={c.svcTag}>{tg}</span>)}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* View all services CTA */}
                    <div style={{ textAlign: 'center', marginTop: 40 }}>
                        <Link to="/services" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '13px 32px', background: 'rgba(29,78,216,0.12)', border: '1px solid rgba(29,78,216,0.3)', borderRadius: 12, color: '#60a5fa', fontSize: 15, fontWeight: 700, textDecoration: 'none', transition: 'background 0.2s, border-color 0.2s' }}
                            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(29,78,216,0.22)'; e.currentTarget.style.borderColor = 'rgba(29,78,216,0.5)'; }}
                            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(29,78,216,0.12)'; e.currentTarget.style.borderColor = 'rgba(29,78,216,0.3)'; }}
                        >
                            {t('services.viewAll') || 'View All Services →'}
                        </Link>
                    </div>
                </div>
            </section>

            {/* ── SUBSCRIPTION PLANS — 2026-08-05: dismesse, sezione nascosta ── */}
            {false && (
            <div style={c.subWrap} id="subscription">
                <div style={c.section} className="og-section">
                    <span style={c.secH}>{home.plansLabel}</span>
                    <h2 style={c.secTitle}>{home.plansTitle}</h2>
                    <p style={c.secSub}>{home.plansSub}</p>
                    <div style={{ display: 'flex', gap: 12, marginTop: 32, flexWrap: 'wrap' }}>
                        {home.highlights.map(h => (
                            <div key={h} style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(29,78,216,0.08)', border: '1px solid rgba(29,78,216,0.2)', borderRadius: 100, padding: '7px 16px', fontSize: 13, color: '#93c5fd' }}>
                                {h}
                            </div>
                        ))}
                    </div>
                    {/* Trial callout */}
                    {home.trial && (
                        <div style={{ marginTop: 40, background: 'linear-gradient(135deg, rgba(6,182,212,0.08), rgba(29,78,216,0.12))', border: '1px solid rgba(6,182,212,0.3)', borderRadius: 16, padding: '24px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }} className="og-trial-banner">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16, flex: 1, minWidth: 280 }}>
                                <span style={{ display: 'inline-flex', padding: '4px 12px', background: 'rgba(6,182,212,0.25)', border: '1px solid rgba(6,182,212,0.4)', borderRadius: 100, fontSize: 11, fontWeight: 800, color: '#06b6d4', letterSpacing: 1, whiteSpace: 'nowrap' }}>
                                    {home.trial.badge}
                                </span>
                                <div>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: '#f1f5f9', marginBottom: 2 }}>{home.trial.title}</div>
                                    <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>{home.trial.desc}</div>
                                </div>
                            </div>
                            <button onClick={() => navigate('/register')} className="og-btn-primary" style={{ whiteSpace: 'nowrap', padding: '12px 28px', fontSize: 14 }}>
                                {home.trial.cta}
                            </button>
                        </div>
                    )}

                    <div style={c.planGrid} className="og-plan-grid">
                        {home.plans.map(p => (
                            <div key={p.name}
                                style={{ ...c.planCard, ...(p.hot ? c.planCardHot : {}) }}
                                className={`og-plan-card${p.hot ? ' og-plan-hot' : ''}`}
                            >
                                {p.hot && <div style={c.planBadge}>{home.mostPopular}</div>}
                                {!p.hot && p.savePct && <div style={{ ...c.planBadge, background: 'rgba(6,182,212,0.8)' }}>Save {p.savePct}%</div>}
                                <div style={{ ...c.planName, marginTop: p.savePct || p.hot ? 8 : 0 }}>{p.name}</div>
                                <div style={c.planPrice}>
                                    <span style={c.planAmt}>{fmtEur(p.price_per_1k)}</span>
                                </div>
                                <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>{home.per1k || '/1,000 accounts'}</div>
                                <div style={{ fontSize: 14, color: '#60a5fa', fontWeight: 600, marginBottom: 16 }}>{p.perAccount}</div>
                                <ul style={c.planFeat}>
                                    {p.features.map(f => (
                                        <li key={f} style={c.planFeatItem}>
                                            <span style={c.planCheck}>✓</span><span>{f}</span>
                                        </li>
                                    ))}
                                </ul>
                                <button onClick={() => navigate('/register')}
                                    className={p.hot ? 'og-btn-primary' : 'og-btn-secondary'}
                                    style={{ width: '100%', textAlign: 'center', marginTop: 4 }}>
                                    {p.cta}
                                </button>
                            </div>
                        ))}
                    </div>
                    <div style={c.subNote}>{home.planNote}</div>
                </div>
            </div>
            )}

            {/* ── ZENITH ────────────────────────────────────────────────── */}
            <section id="zenith" style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(109,40,217,0.14) 0%, transparent 65%)', borderTop: '1px solid rgba(109,40,217,0.2)', borderBottom: '1px solid rgba(109,40,217,0.12)', padding: '96px 0' }} className="og-zenith-section">
                <div style={c.section} className="og-section">
                    {/* Header row: logo + badge */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 24, flexWrap: 'wrap' }}>
                        <img src="/zenith-logo.svg" alt="Zenith" style={{ height: 130, width: 'auto' }} />
                        <span style={{ display: 'inline-flex', padding: '5px 16px', background: 'rgba(109,40,217,0.3)', border: '1px solid rgba(139,92,246,0.55)', borderRadius: 100, fontSize: 11, fontWeight: 800, color: '#c4b5fd', letterSpacing: 2, textTransform: 'uppercase' }}>
                            {zc.badge}
                        </span>
                    </div>
                    <span style={{ ...c.secH, color: '#a78bfa' }}>{zc.label}</span>
                    <h2 style={{ ...c.secTitle, maxWidth: 620 }}>{zc.title}</h2>
                    <p style={{ ...c.secSub, marginBottom: 48 }}>{zc.sub}</p>
                    {/* Plan cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginBottom: 48 }} className="og-zenith-plans">
                        {zc.plans.map((p, i) => (
                            <div key={p.name} style={{ background: i === 1 ? 'rgba(109,40,217,0.16)' : 'rgba(109,40,217,0.06)', border: `1px solid ${i === 1 ? 'rgba(139,92,246,0.5)' : 'rgba(109,40,217,0.2)'}`, borderRadius: 16, padding: '28px 24px', position: 'relative' }}>
                                {i === 1 && <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: 'linear-gradient(90deg, #7c3aed, #a855f7)', borderRadius: '16px 16px 0 0' }} />}
                                <div style={{ fontSize: 16, fontWeight: 800, color: '#e9d5ff', marginBottom: 8 }}>{p.name}</div>
                                <div style={{ display: 'flex', alignItems: 'baseline', gap: 2, marginBottom: 12 }}>
                                    <span style={{ fontSize: 32, fontWeight: 900, color: '#c4b5fd', letterSpacing: '-1px' }}>{p.price}</span>
                                    <span style={{ fontSize: 13, color: '#64748b', marginLeft: 2 }}>{p.period}</span>
                                </div>
                                <div style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.65 }}>{p.desc}</div>
                            </div>
                        ))}
                    </div>
                    {/* CTA */}
                    <a href="https://t.me/orbitgrowth" target="_blank" rel="noopener noreferrer"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 32px', background: 'linear-gradient(135deg, #6d28d9, #7c3aed)', color: '#fff', borderRadius: 12, fontSize: 15, fontWeight: 700, textDecoration: 'none', boxShadow: '0 4px 24px rgba(109,40,217,0.45)' }}>
                        {zc.cta}
                    </a>
                    <p style={{ marginTop: 16, fontSize: 13, color: '#475569' }}>Full onboarding within 48h · Monthly contract · Cancel anytime</p>
                </div>
            </section>

            {/* ── CTA ───────────────────────────────────────────────────── */}
            <div style={{ ...c.ctaWrap, position: 'relative', overflow: 'hidden' }} className="og-cta-section">
                <div className="og-cta-glow" />
                <h2 style={c.ctaTitle}>
                    {home.ctaTitle.split('orbit').map((part, i) =>
                        i === 0 ? part : <React.Fragment key={i}><span className="og-gradient-text">orbit</span>{part}</React.Fragment>
                    )}
                </h2>
                <p style={c.ctaSub}>{home.ctaSub}</p>
                <button onClick={() => navigate('/register')} className="og-btn-primary" style={{ fontSize: 17, padding: '16px 48px' }}>
                    {home.ctaBtn}
                </button>
                <div style={{ marginTop: 20, fontSize: 13, color: '#334155' }}>{home.ctaNote}</div>
                {home.ctaTrial && (
                    <div style={{ marginTop: 14, display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 20px', background: 'rgba(6,182,212,0.1)', border: '1px solid rgba(6,182,212,0.25)', borderRadius: 100, fontSize: 13, color: '#67e8f9', fontWeight: 600 }}>
                        {home.ctaTrial}
                    </div>
                )}
                {/* Contact links in CTA section */}
                <div style={{ marginTop: 20, display: 'flex', gap: 20, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
                    <a href="https://t.me/orbitgrowth" target="_blank" rel="noopener noreferrer"
                        style={{ color: '#60a5fa', fontSize: 13, textDecoration: 'none' }}>
                        💬 Telegram: @orbitgrowth
                    </a>
                    <span style={{ color: '#1e293b' }}>·</span>
                    <a href="mailto:orbitgrowth.staff@gmail.com"
                        style={{ color: '#475569', fontSize: 13, textDecoration: 'none' }}>
                        ✉ orbitgrowth.staff@gmail.com
                    </a>
                </div>
            </div>

            {/* ── FOOTER ────────────────────────────────────────────────── */}
            <footer style={c.footer} className="og-footer-wrap">
                <a style={c.footerLogo} href="/">
                    <img src="/logo.svg" alt="OrbitGrowth" style={{ height: 40, width: 'auto' }} />
                </a>
                <div style={c.footerLinks}>
                    <a style={c.footerLink} href="/">{common.footer.home}</a>
                    <a style={c.footerLink} href="/pricing">{common.footer.pricing}</a>
                    <a style={c.footerLink} href="/api-docs">{common.footer.apiDocs}</a>
                    <a style={c.footerLink} href="/terms">{common.footer.terms}</a>
                    <a style={c.footerLink} href="/login">{common.footer.login}</a>
                    <a style={c.footerLink} href="/register">{common.footer.register}</a>
                </div>
                <span style={c.footerCopy}>© {new Date().getFullYear()} OrbitGrowth</span>
                {/* Contact row — required by payment processors */}
                <div style={{ width: '100%', borderTop: '1px solid rgba(255,255,255,0.04)', marginTop: 8, paddingTop: 14, display: 'flex', gap: 28, justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
                    <a href="https://t.me/orbitgrowth" target="_blank" rel="noopener noreferrer"
                        style={{ color: '#60a5fa', fontSize: 13, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{ fontSize: 16 }}>✈</span> Telegram: @orbitgrowth
                    </a>
                    <a href="mailto:orbitgrowth.staff@gmail.com"
                        style={{ color: '#64748b', fontSize: 13, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{ fontSize: 14 }}>✉</span> orbitgrowth.staff@gmail.com
                    </a>
                </div>
            </footer>
        </div>
    );
}
